<template>
  <div>
    <b-row>
      <b-col
        md="auto"
      >
        <b-form-group v-if="dataItem.id">
          <b-form-checkbox
            v-model="changePassword"
            switch
          >
            {{ $t('users.form.changePassword') }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col
        md="auto"
      >
        <b-form-group>
          <b-form-checkbox
            v-model="dataItem.secret_files"
            switch
            :value="'1'"
          >
            {{ $t('users.form.secretFiles') }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col
        v-if="changePassword || !dataItem.id"
        cols="12"
      >
        <b-form-group
          :label="$t('users.form.password')"
          label-for="password"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('users.form.password')"
            rules="required"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="password"
                v-model="dataItem.password"
                :type="passwordFieldType"
                :placeholder="$t('users.form.password')"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIcon"
                  class="cursor-pointer"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BFormGroup, BFormInput, BInputGroupAppend,
  BInputGroup, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  name: 'UserName',
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BRow,
    BCol,
    BFormCheckbox,
    ValidationProvider,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      required,
      changePassword: false,
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    dataItem() {
      return this.$store.getters['users/dataItem']
    },

  },
}
</script>

<style scoped>

</style>
